import { render, staticRenderFns } from "./editBoxWithHeader.vue?vue&type=template&id=c98c13a0&scoped=true&"
import script from "./editBoxWithHeader.vue?vue&type=script&lang=js&"
export * from "./editBoxWithHeader.vue?vue&type=script&lang=js&"
import style0 from "./editBoxWithHeader.vue?vue&type=style&index=0&id=c98c13a0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c98c13a0",
  null
  
)

export default component.exports